import axios from "axios";
import { userDataLocalStorage } from "../../../general/functions/base64Function";
import {
  SMVM_GET_PRIVATE_NOTE_FAIL,
  SMVM_GET_PRIVATE_NOTE_REQUEST,
  SMVM_GET_PRIVATE_NOTE_RESET,
  SMVM_GET_PRIVATE_NOTE_SUCCESS,
  SMVM_SET_PRIVATE_NOTE_FAIL,
  SMVM_SET_PRIVATE_NOTE_REQUEST,
  SMVM_SET_PRIVATE_NOTE_RESET,
  SMVM_SET_PRIVATE_NOTE_SUCCESS,
} from "../constants/privateNoteConstants";
import { API_GET_PRIVATE_NOTE, API_SET_PRIVATE_NOTE } from "../init/api_url";

export const RSetPrivateNote = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_SET_PRIVATE_NOTE_RESET,
  });
};

export const SetPrivateNote = (text) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");

  try {
    dispatch({
      type: SMVM_SET_PRIVATE_NOTE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_SET_PRIVATE_NOTE(projectCode),
      { note: text, sessionId: sessionId },
      config
    );

    dispatch({
      type: SMVM_SET_PRIVATE_NOTE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_SET_PRIVATE_NOTE_FAIL,
      payload: message,
    });
  }
};

export const RGetPrivateNote = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_GET_PRIVATE_NOTE_RESET,
  });
};

export const GetPrivateNote = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");

  try {
    dispatch({
      type: SMVM_GET_PRIVATE_NOTE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        sessionId: sessionId,
      },
    };
    const { data: data } = await axios.get(
      API_GET_PRIVATE_NOTE(projectCode),
      config
    );

    dispatch({
      type: SMVM_GET_PRIVATE_NOTE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_GET_PRIVATE_NOTE_FAIL,
      payload: message,
    });
  }
};
